import { ref, onMounted, onBeforeUnmount } from "vue";

export function useScrollSpy(sectionIds, offset = 120) {
  const activeSection = ref(sectionIds[0] || "");
  const isScrolled = ref(false);

  const update = () => {
    isScrolled.value = window.scrollY > 24;

    let current = sectionIds[0];
    for (const id of sectionIds) {
      const element = document.getElementById(id);
      if (element && element.getBoundingClientRect().top <= offset) {
        current = id;
      }
    }
    activeSection.value = current;
  };

  onMounted(() => {
    window.addEventListener("scroll", update, { passive: true });
    update();
  });

  onBeforeUnmount(() => {
    window.removeEventListener("scroll", update);
  });

  return { activeSection, isScrolled };
}
